// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"c_","newscontentBox":"c_"};